import React, { useEffect, useState, useRef } from 'react';
import Link from '../components/Link';

const Home = ({width, height}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const longPressTimer = useRef(null);

  const menuItems = [
    {
      top  : '12vw',
      left : '16vw',
      url  : '/video/powerplay/'
    },
    {
      top  : '20vw', 
      left : '46.7vw',
      url  : '/energy/'
    },
    {
      top  : '42vw', 
      left :'19.3vw',
      url  : '/powerforward/'
    },
    {
      top :'12vw', 
      right:'5vw',
      url  : '/gettoknow/'
    },
    {
      top:'43vw', 
      left:'55vw',
      url  : '/renew/'
    },
    {
      top:'39vw', 
      right:'10vw',
      url  : '/powerhours/'
    }
  ];

  const enterFullscreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const handleButtonMouseDown = () => {
    if (isFullscreen) {
      // Start long press timer for exit
      //longPressTimer.current = setTimeout(() => {
        exitFullscreen();
      //}, 3000);
    } else {
      // Enter fullscreen immediately
      enterFullscreen();
    }
  };

  const handleButtonMouseUp = () => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  return (
    <div className="home w-full h-full bg-cover bg-center" style={{backgroundImage : 'url("./assets/screenc-background.png")'}}>
      
      {menuItems.map((item) => (
        <Link key={item.url} to={item.url}>
          <div
            className='absolute'
            style={{
              padding: '5vw',
              top: item.top,
              left: item.left,
              right: item.right
            }}
          >
            <img 
              src={'./assets/play-button.svg'} 
              className='shadow-md shadow-gray-500 rounded-full heartbeat-image' 
              style={{width:'4vw'}} 
            />
          </div>
        </Link>
      ))}
      
      <Link to={"/video/all"} className='absolute bottom-0 right-0'>
        <div className='block opacity-0 cursor-pointer' style={{width:"6vw", height:"6vw"}}></div>
      </Link>

      <button
        className="absolute bottom-2 left-2 bg-transparent text-white opacity-80"
        onMouseDown={handleButtonMouseDown}
        onMouseUp={handleButtonMouseUp}
        onMouseLeave={handleButtonMouseUp}
        style={{zIndex : '1001', width : '4vw', height : '4vw', fontSize : '2.5vw'}}
        aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      >
        <i className={isFullscreen ? 'fa-solid fa-compress opacity-50' : 'fa-solid fa-expand'} style={{color:"#888888"}}></i>
      </button>
    </div>
  )
}

export default Home